import { render, staticRenderFns } from "./ResourceManage.vue?vue&type=template&id=58f6b73a&scoped=true&"
import script from "./ResourceManage.vue?vue&type=script&lang=js&"
export * from "./ResourceManage.vue?vue&type=script&lang=js&"
import style0 from "./ResourceManage.vue?vue&type=style&index=0&id=58f6b73a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f6b73a",
  null
  
)

export default component.exports